const LEO_PORTRAIT =
  "https://customer-assets.emergentagent.com/job_smart-money-trading-4/artifacts/6z980ctf_1.jpeg";

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-32 lg:py-40 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-16 items-start">
          {/* Portrait */}
          <div className="lg:col-span-5 relative">
            <div className="relative aspect-[3/4] overflow-hidden rounded-3xl border border-white/10">
              <img
                src={LEO_PORTRAIT}
                alt="Portrait of Leo Bianchi"
                className="w-full h-full object-cover grayscale-[0.15]"
                data-testid="about-portrait"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
              <div className="absolute bottom-6 left-6 right-6 sm:right-32">
                <div className="text-xs uppercase tracking-[0.3em] text-amber-500">
                  Leo Bianchi
                </div>
                <div className="font-serif-display text-2xl text-white mt-1">
                  Investor · Stock Picker · Mentor
                </div>
              </div>
            </div>
            {/* Signature accent */}
            <div className="absolute -bottom-6 -right-6 hidden sm:block">
              <div className="bg-black border border-amber-600/40 px-5 py-4 rounded-2xl">
                <div className="font-serif-display italic text-amber-500 text-2xl">
                  L. Bianchi
                </div>
                <div className="text-[10px] uppercase tracking-[0.3em] text-zinc-500">
                  Mentor signature
                </div>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="lg:col-span-7 lg:pl-8">
            <p className="text-xs uppercase tracking-[0.35em] text-amber-500 mb-6">
              — About
            </p>
            <h2
              data-testid="about-headline"
              className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-white"
            >
              17. Three years in.
              <br />
              Building <em className="italic text-amber-400">real wealth.</em>
            </h2>

            <div className="mt-10 space-y-6 text-zinc-400 text-lg leading-relaxed max-w-2xl">
              <p>
                I started investing at 14 — not because I had a lot of money,
                but because I refused to let what little I had sit in a savings
                account quietly losing to inflation while banks earned the
                interest off my back.
              </p>
              <p>
                Three years later my portfolio is built on long-term conviction
                picks with strong returns. No memes, no hype, no gambling — just
                research, patience, and a process that actually compounds.
              </p>
              <p className="text-zinc-300">
                Now I help everyday people — students, parents, anyone tired of
                their money going nowhere — actually start building real
                wealth.
              </p>
            </div>

            {/* Credentials grid */}
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-px mt-14 bg-white/10 rounded-2xl overflow-hidden border border-white/10">
              {[
                { v: "Age 17", l: "Investing since 14" },
                { v: "3 yrs", l: "In the markets" },
                { v: "Self-taught", l: "Hours of research" },
                { v: "Strong", l: "Track record" },
                { v: "1:1", l: "Personal mentor" },
                { v: "Long-term", l: "Portfolio focus" },
              ].map((c) => (
                <div
                  key={c.l}
                  className="bg-[#0A0A0A] p-6"
                  data-testid={`about-credential-${c.l.replace(/\s/g,'-').toLowerCase()}`}
                >
                  <div className="font-serif-display text-2xl text-white">
                    {c.v}
                  </div>
                  <div className="text-xs uppercase tracking-[0.25em] text-zinc-500 mt-1">
                    {c.l}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
